var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 677,
    height: 594,
    viewBox: "0 0 677 594",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2784_509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 677,
    height: 594
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 675,
    height: 592,
    rx: 12,
    fill: "url(#paint0_linear_2784_509)",
    stroke: "#BB9370",
    strokeOpacity: 0.16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2784_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339 -80L343.619 184.871L375.899 -78.0662L352.805 185.836L412.393 -72.2861L361.841 187.757L448.083 -62.723L370.626 190.612L482.578 -49.4815L379.065 194.369L515.5 -32.707L387.064 198.987L546.488 -12.583L394.538 204.417L575.203 10.6699L401.402 210.598L601.33 36.7969L407.583 217.462L624.583 65.5118L413.013 224.936L644.707 96.5L417.631 232.935L661.482 129.422L421.388 241.374L674.723 163.917L424.243 250.159L684.286 199.607L426.164 259.195L690.066 236.101L427.129 268.381L692 273L427.129 277.619L690.066 309.899L426.164 286.805L684.286 346.393L424.243 295.841L674.723 382.083L421.388 304.626L661.482 416.578L417.631 313.065L644.707 449.5L413.013 321.064L624.583 480.488L407.583 328.538L601.33 509.203L401.402 335.402L575.203 535.33L394.538 341.583L546.488 558.583L387.064 347.013L515.5 578.707L379.065 351.631L482.578 595.482L370.626 355.388L448.083 608.723L361.841 358.243L412.393 618.286L352.805 360.164L375.899 624.066L343.619 361.129L339 626L334.381 361.129L302.101 624.066L325.195 360.164L265.607 618.286L316.159 358.243L229.917 608.723L307.374 355.388L195.422 595.482L298.935 351.631L162.5 578.707L290.936 347.013L131.512 558.583L283.462 341.583L102.797 535.33L276.598 335.402L76.6699 509.203L270.417 328.538L53.417 480.488L264.987 321.064L33.293 449.5L260.369 313.065L16.5185 416.578L256.612 304.626L3.27704 382.083L253.757 295.841L-6.2861 346.393L251.836 286.805L-12.0662 309.899L250.871 277.619L-14 273L250.871 268.381L-12.0662 236.101L251.836 259.195L-6.2861 199.607L253.757 250.159L3.27704 163.917L256.612 241.374L16.5185 129.422L260.369 232.935L33.293 96.5L264.987 224.936L53.417 65.5118L270.417 217.462L76.6699 36.7969L276.598 210.598L102.797 10.6699L283.462 204.417L131.512 -12.583L290.936 198.987L162.5 -32.707L298.935 194.369L195.422 -49.4815L307.374 190.612L229.917 -62.723L316.159 187.757L265.607 -72.2861L325.195 185.836L302.101 -78.0662L334.381 184.871L339 -80Z",
    fill: "url(#paint1_linear_2784_509)",
    fillOpacity: 0.15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2784_509",
    x1: 1.00004,
    y1: 0.999967,
    x2: 541.746,
    y2: 617.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#121011",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C87BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2784_509",
    x1: 342.879,
    y1: 734.615,
    x2: 342.879,
    y2: 51.8901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1E6D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168908,
    stopColor: "#F1E6D2",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1E6D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.cc0c49043a902996b1306f6da4e445d3.svg";
export { ForwardRef as ReactComponent };